import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSafetyCallFirefighters2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "safety-call-firefighters-2" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.75,23.25c-3,0-6-1.666-6-5,0-3,2.25-5,3.6-5-.3,1.667-.45,3,1.35,3,2.7,0,1.967-4.36-.9-8,3.728,0,7.95,4.167,7.95,8.334C18.75,19.917,17.1,23.25,12.75,23.25Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,9A8.25,8.25,0,0,1,9,.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M5.25,9A3.75,3.75,0,0,1,9,5.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.25,9A8.25,8.25,0,0,0,15,.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.75,9A3.75,3.75,0,0,0,15,5.25"
		})
	]
});
export default SvgSafetyCallFirefighters2;
